import { pick } from 'lodash';
import db from '../../lib/db';
import { WarriorType } from '../../lib/types';

export type Message = {
  message?: string;
  messageKey?: string;
  messageData?: Record<string, string>;
  system?: boolean;
  warrior?: Pick<WarriorType, 'id' | 'login' | 'level'>;
  timestamp: number;
  private?: boolean;
  to?: Pick<WarriorType, 'id' | 'login' | 'level'>;
};

const COMMENTATOR_WARRIOR = {
  id: 'StormFire',
  login: 'StormFire',
  level: '8',
};

export const pickWarriorData = (warrior: WarriorType) => {
  return pick(warrior, ['login', 'id', 'level']);
};

export const createMessage = async (message: Partial<Message>, path: string = 'chat') => {
  const timestamp = Date.now();
  await db()
    .child(path)
    .child(timestamp)
    .set({
      ...message,
      timestamp: message.timestamp || timestamp,
    });
};

export const sendSystemMsg = async (message: Message) => {
  await createMessage({
    system: true,
    // @ts-ignore
    warrior: COMMENTATOR_WARRIOR,
    ...message,
  });
};

export const sendAdminMsg = async (message: Message, suppressNotification = false) => {
  await createMessage({
    system: true,
    private: true,
    // @ts-ignore
    to: COMMENTATOR_WARRIOR,
    // @ts-ignore
    warrior: COMMENTATOR_WARRIOR,
    ...message,
  });

  if ((global as any).ENV === 'backend' && !suppressNotification) {
    // await sendNotification({
    //   body: message.message,
    // });
    await sendMsg(message.message);
  }
};

export const sendMsg = async (msg: any) => {
  // Best-effort Discord telemetry. A webhook/network failure must never reject:
  // callers fire this without awaiting, and on Node an unhandled rejection would
  // crash the Lambda runtime (→ 502) and break the action that triggered it.
  try {
    await fetch(
      'https://discord.com/api/webhooks/1375008596097634344/yQZCw2KDEJoUUviuAXWQE-BSJmDScmpX5iOTJeJvrQgOBE2XwRrHhs6YGPhdDycweDG9',
      {
        body: JSON.stringify({
          content: msg,
        }),
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
      },
    );
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('sendMsg (discord webhook) failed:', (e as any)?.message || e);
  }
};
